var Raw = /** @class */ (function () {
    function Raw(value) {
        // consumed in expr_formatter.js
        this.type = 'raw';
        if (typeof value !== 'string') {
            throw new Error('invalid type of raw value');
        }
        this.value = value;
    }
    Raw.prototype.toString = function () {
        return this.value;
    };
    Raw.build = function (value) {
        return new Raw(value);
    };
    return Raw;
}());
export default Raw;
;
//# sourceMappingURL=raw.js.map